import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { IncidentHistoryDataProviderFactory } from '../factory/IncidentHistoryDataProviderFactory';
import { IncidentHistoryBaseDataProvider } from '../dataProvider/IncidentHistoryBaseDataProvider';
import { IncidentHistoryResults, IncidentHistoryWebComponentSchema } from '../types';

export class IncidentHistoryRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IncidentHistoryDataProviderFactory;
  public dataProvider: IncidentHistoryBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IncidentHistoryDataProviderFactory(),
    });
  }

  async getDataForView(page: number): Promise<{ incidentsHistoryResults: IncidentHistoryResults }> {
    return this.dataProvider.getDataForView(page);
  }
}
